import { QueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

/**
 * Shared query defaults.
 *
 * Authorisation failures are never retried: a 401 is already handled by the token refresh
 * interceptor, and a 403 will not become a 200 on the third attempt.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (isAxiosError(error)) {
          const status = error.response?.status;
          if (status && status >= 400 && status < 500) return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
      /**
       * Fail rather than pause when the browser is offline.
       *
       * React Query's default holds an offline mutation in a pending state indefinitely, so a
       * cashier who loses connection mid-checkout sees a spinner that never resolves and has no way
       * to tell whether the sale happened. Failing visibly is the only honest option for a screen
       * that takes money — and the counter blocks checkout while offline anyway, so this is the
       * safety net rather than the first line of defence.
       */
      networkMode: 'always',
    },
  },
});
